import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { TranslationProvider, useTranslation } from '@ibk/shared-translation';
import { InlineError, Radio } from '@ibk/shared-ui';
import { AdvancedSelector } from '../../components';
import translations from '../../translations';
import styles from './TwoFactorSelect.module.css';
import { useTwoFactorSelect } from './useTwoFactorSelect';
const defaultTexts = {
    title: '',
    continue: '',
    back: '',
};
export function TwoFactorSelectContent({ options, onSelect, onContinue, onBack, loading = false, error = null, theme = {}, texts = {}, }) {
    const { t } = useTranslation();
    const mergedTexts = {
        ...defaultTexts,
        title: t('auth.2fa.select.title'),
        continue: t('auth.2fa.select.continue'),
        back: t('auth.2fa.select.back'),
        ...texts,
    };
    const { selected, handleSelect, handleContinue, loading: isLoading, error: displayError, showInlineError, setShowInlineError, } = useTwoFactorSelect({
        onSelect,
        onContinue,
        onBack,
        loading,
        error,
    });
    const handleKeyDown = (event) => {
        if (event.target.tagName === 'BUTTON') {
            return;
        }
        if (event.key === 'Enter' && selected && !isLoading) {
            event.preventDefault();
            handleContinue();
            return;
        }
        if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
            event.preventDefault();
            const currentIndex = selected ? options.findIndex(opt => opt.value === selected) : -1;
            let nextIndex;
            if (event.key === 'ArrowDown') {
                nextIndex = currentIndex < options.length - 1 ? currentIndex + 1 : 0;
            }
            else {
                nextIndex = currentIndex > 0 ? currentIndex - 1 : options.length - 1;
            }
            handleSelect(options[nextIndex].value);
        }
    };
    const rootRef = React.useRef(null);
    React.useEffect(() => {
        rootRef.current?.focus();
    }, []);
    const handleSubmit = (event) => {
        event.preventDefault();
        if (selected && !isLoading) {
            handleContinue();
        }
    };
    const styleVars = {
        '--color-primary': theme.primaryColor ?? undefined,
        '--color-surface': theme.cardBackground ?? undefined,
        '--color-background': theme.background ?? undefined,
    };
    return (_jsx("div", { className: styles.selectRoot, style: styleVars, children: _jsxs("form", { ref: rootRef, className: styles.selectCardWrapper, onSubmit: handleSubmit, onKeyDown: handleKeyDown, tabIndex: 0, "aria-label": mergedTexts.title.replace(/<[^>]*>/g, ''), children: [_jsx("div", { className: styles.selectFormTitle, dangerouslySetInnerHTML: { __html: mergedTexts.title } }), _jsx(AdvancedSelector, { options: options, selected: selected, onSelect: handleSelect, radioComponent: Radio }), showInlineError && displayError && (_jsx(InlineError, { message: displayError, onClose: () => setShowInlineError(false), "data-testid": '2fa-inline-error' })), _jsx("button", { type: 'submit', className: styles.selectButton, disabled: !selected || isLoading, "data-testid": '2fa-continue-button-continue', children: mergedTexts.continue }), _jsx("button", { type: 'button', className: styles.backButton, onClick: onBack, disabled: isLoading, "data-testid": '2fa-back-button-back', children: mergedTexts.back })] }) }));
}
export function TwoFactorSelect(props) {
    return (_jsx(TranslationProvider, { translations: translations, defaultLanguage: 'pt-BR', children: _jsx(TwoFactorSelectContent, { ...props }) }));
}
